/**
 * How a marked attempt is judged — the one rule every screen uses: the
 * student's exam history and results reports, and the admin's correction list.
 *
 * Kept apart from `examHelpers.js`, which reads the store, so that anything can
 * import it — the student module, and a test with no store behind it.
 *
 * TWO DECIMALS
 *
 * Grades and pass marks are compared at the precision the screens print them
 * at, so a grade that reads "36" is never "failed" against a pass mark of "36".
 * It also takes the server's float noise off: each question is worth the full
 * mark over the count to nine places, so three right answers of three come back
 * as 99.999999999, and three of six as 49.999999998.
 */
export const roundScore = (value) => Math.round((Number(value) || 0) * 100) / 100;

/**
 * The pass mark: the full mark times the exam's success ratio. Not rounded to a
 * whole mark — 70% of 25 is 17.5, and rounding it up to 18 would ask for 72%.
 */
export const passMarkOf = (totalDegree, successRatio) =>
    roundScore((Number(totalDegree) || 0) * (Number(successRatio) || 0));

/**
 * Whether an attempt passed: its grade reaches the pass mark. The fields are a
 * finished round's — `/round/exam/finished/course/:id` and `/analysis` both
 * carry them — and each is read as a number, whatever type it arrives in. An
 * attempt at an exam worth nothing has nothing to pass.
 */
export const isPassed = ({ worthDegree, examTotalDegree, examSuccessRatio }) => (
    (Number(examTotalDegree) || 0) > 0
    && roundScore(worthDegree) >= passMarkOf(examTotalDegree, examSuccessRatio)
);
